export default "__VITE_ASSET__DGgTRHMy__ 640w, __VITE_ASSET__CIqKlABE__ 1024w, __VITE_ASSET__CUeqTOGC__ 1280w";